<template>
  <div class="highlight-pic">
    <div
      class="return"
    >
      <p @click="returnBtn" plain>{{ $t("home.returnbtn") }}</p>
    </div>
    <div class="pic-box">
      <el-image
        :lazy="true"
        class="img"
        v-for="(item, index) in albumList"
        :key="index"
        :src="item.temp_photo_path_url"
        ><div slot="placeholder" class="image-slot">
          <i class="el-icon-loading"></i>
        </div>
      </el-image>
      <!-- <li
        :lazy="true"
        class="img"
        v-for="(item, index) in images[this.id]"
        :key="index"
        :src="item"
        ><ul slot="placeholder" class="image-slot">
          <p>{{item}}</p>
        </ul>
      </li> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { BasketballApi } from "../../../api/basketball";
export default {
  data() {
    return {
      albumList: ""
    };
  },
  methods: {
    returnBtn() {
      this.$router.push({path:'/corporate?type=1', query: {tab:'highlight'}});
    },
    getAlbumImageCorporate() {
      BasketballApi.getCorporateAlbumList(this.id)
        .then(res => {
          this.albumList = res
        })
        .catch(err => console.log(err.message));
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.getAlbumImageCorporate();
  },
  computed: {
    ...mapState(["headType"])
  }
};
</script>

<style lang="scss" scoped>
.highlight-pic {
  width: 80%;
  margin-left: 10%;
  .return {
    background: #5e98ca;
    float: right;
    margin-right: 20px;
    color: #fff;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    @media screen and (max-width: 768px) {
      margin-right: 0px;
    }
  }
  .return:hover {
    font-weight: 600;
  }
  .pic-box {
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .img {
      width: 30%;
      height: 200px;
      margin: 30px 0;
      border-radius: 10px;
      cursor: pointer;
    }
    @media screen and (max-width: 768px) {
      flex-direction: column;
      .img {
        width: 100%;
        margin: 10px 0;
      }
    }
  }
}
</style>
